var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVosklicatelSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 29,
    viewBox: "0 0 7 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4176_15750",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04688 5.02734L5.27344 19.3125H1.61719L0.84375 5.02734H6.04688ZM5.66016 20.2031V24H1.23047V20.2031H5.66016Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04688 5.02734L7.04541 5.08141L7.10248 4.02734H6.04688V5.02734ZM5.27344 19.3125V20.3125H6.22076L6.27198 19.3666L5.27344 19.3125ZM1.61719 19.3125L0.61865 19.3666L0.669866 20.3125H1.61719V19.3125ZM0.84375 5.02734V4.02734H-0.211857L-0.154787 5.08141L0.84375 5.02734ZM5.66016 20.2031H6.66016V19.2031H5.66016V20.2031ZM5.66016 24V25H6.66016V24H5.66016ZM1.23047 24H0.230469V25H1.23047V24ZM1.23047 20.2031V19.2031H0.230469V20.2031H1.23047ZM5.04834 4.97328L4.2749 19.2584L6.27198 19.3666L7.04541 5.08141L5.04834 4.97328ZM5.27344 18.3125H1.61719V20.3125H5.27344V18.3125ZM2.61573 19.2584L1.84229 4.97328L-0.154787 5.08141L0.61865 19.3666L2.61573 19.2584ZM0.84375 6.02734H6.04688V4.02734H0.84375V6.02734ZM4.66016 20.2031V24H6.66016V20.2031H4.66016ZM5.66016 23H1.23047V25H5.66016V23ZM2.23047 24V20.2031H0.230469V24H2.23047ZM1.23047 21.2031H5.66016V19.2031H1.23047V21.2031Z",
    fill: "#C691FB",
    mask: "url(#path-1-inside-1_4176_15750)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVosklicatelSign);
export default __webpack_public_path__ + "static/media/vosklicatel_sign.8dcaacdcaddcc5335ea1ce3aa5fb0598.svg";
export { ForwardRef as ReactComponent };